
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./vue-apollo-9-pagination.json") })
        }
      }, "path---vue-apollo-9-pagination");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---vue-apollo-9-pagination!./.cache/json/vue-apollo-9-pagination.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---vue-apollo-9-pagination!./.cache/json/vue-apollo-9-pagination.json
// module chunks = 154